var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.779 6.00047C13.779 6.12714 13.7324 6.2538 13.6324 6.3538L9.2857 10.7005C8.57904 11.4071 7.41904 11.4071 6.71237 10.7005L2.3657 6.3538C2.17237 6.16047 2.17237 5.84047 2.3657 5.64714C2.55904 5.4538 2.87904 5.4538 3.07237 5.64714L7.41904 9.9938C7.73904 10.3138 8.25904 10.3138 8.57904 9.9938L12.9257 5.64714C13.119 5.4538 13.439 5.4538 13.6324 5.64714C13.7257 5.74714 13.779 5.8738 13.779 6.00047Z",
    fill: "#2991FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropArrow);
export default __webpack_public_path__ + "static/media/dropArrow.a0b4d704f2b791f2610a3ae913a46acf.svg";
export { ForwardRef as ReactComponent };